"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteField = void 0;
const create_field_component_1 = __importDefault(require("../form-group/create-field-component"));
const autocomplete_1 = __importDefault(require("./autocomplete"));
exports.AutocompleteField = (0, create_field_component_1.default)(autocomplete_1.default);
exports.default = exports.AutocompleteField;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0b2NvbXBsZXRlLWZpZWxkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy9hdXRvY29tcGxldGUvYXV0b2NvbXBsZXRlLWZpZWxkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtHQUF3RTtBQUN4RSxrRUFBMEM7QUFFN0IsUUFBQSxpQkFBaUIsR0FBRyxJQUFBLGdDQUFvQixFQUFDLHNCQUFZLENBQUMsQ0FBQztBQUNwRSxrQkFBZSx5QkFBaUIsQ0FBQyJ9